const ITEMS = [
  "AMOR FATI",
  "MEMENTO MORI",
  "PREMEDITATIO MALORUM",
  "DICOTOMIA DO CONTROLE",
  "CLAREZA MENTAL",
  "RESILIÊNCIA INABALÁVEL",
  "A ARTE DE VIVER",
  "DISCIPLINA DA VONTADE",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif italic text-2xl sm:text-3xl text-[#f4f1ea]/80 px-8 whitespace-nowrap">{item}</span>
        <span className="w-1.5 h-1.5 rotate-45 bg-[#d4af37]/70 shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee-ribbon" className="relative border-y border-[#d4af37]/15 bg-[#0f0f13] py-6 overflow-hidden">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
